(function () {
  const maxPreviewHeight = 560;
  let image = null;
  let outerWrap = null;
  let innerWrap = null;

  function initElements() {
    image = document.querySelector('.ez-resource-show__preview__image');
    outerWrap = document.querySelector('.ez-resource-show__preview__outer-wrap');
    innerWrap = document.querySelector('.ez-resource-show__preview__inner-wrap');
  }

  function getWindowWidth() {
    return window.innerWidth
    || document.documentElement.clientWidth
    || document.body.clientWidth;
  }

  function convertToInt(value) {
    return parseInt(value, 10);
  }

  function setPreviewMaxHeight(resolve) {
    if (getWindowWidth() <= 1101) {
      outerWrap.style.height = null;
      return;
    }

    const previewStyle = window.getComputedStyle(outerWrap);

    if (image.height >= maxPreviewHeight) {
      outerWrap.style.height = `${maxPreviewHeight}px`;
    } else if (convertToInt(previewStyle.maxHeight) < maxPreviewHeight) {
      outerWrap.style.height = null;
    }

    resolve();
  }

  function setPreviewWidth() {
    innerWrap.style.width = '100%';

    if (getWindowWidth() <= 600) return;

    const previewStyle = window.getComputedStyle(outerWrap);
    const vertPadding = convertToInt(previewStyle.paddingTop);
    const horizontalPadding = convertToInt(previewStyle.paddingLeft) + convertToInt(previewStyle.paddingRight);

    const previewWidth = image.width;
    const previewHeight = image.height;

    const containerWidth = outerWrap.clientWidth - horizontalPadding;
    const containerHeight = outerWrap.clientHeight - vertPadding;

    const newWidth = (containerHeight * previewWidth) / previewHeight;
    const newWidthPercentage = (newWidth / containerWidth) * 100;

    innerWrap.style.width = `${newWidthPercentage}%`;
  }

  function resizePreviewElements() {
    initElements();
    const maxHeightPromise = () => new Promise((resolve) => setPreviewMaxHeight(resolve));

    maxHeightPromise().then(() => setPreviewWidth());
  }

  window.ezPreviewResize = resizePreviewElements;
}());
